<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_663_6068"
      style="mask-type: alpha;"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_663_6068)">
      <path
        d="M5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7693 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777ZM5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V2.38477H8.23075V4.50002H15.8078V2.38477H17.3078V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V11.7713C20.2602 11.6661 20.0153 11.5811 19.7653 11.5163C19.5153 11.4516 19.2602 11.4007 19 11.3635V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20H11.8098C11.8943 20.2768 11.9965 20.5387 12.1165 20.7855C12.2363 21.0323 12.3725 21.2705 12.525 21.5H5.30775ZM18.1923 22.5C16.9436 22.5 15.8814 22.0622 15.0058 21.1865C14.1301 20.3108 13.6923 19.2487 13.6923 18C13.6923 16.7513 14.1301 15.6892 15.0058 14.8135C15.8814 13.9378 16.9436 13.5 18.1923 13.5C19.4411 13.5 20.5033 13.9378 21.3788 14.8135C22.2544 15.6892 22.6923 16.7513 22.6923 18C22.6923 19.2487 22.2544 20.3108 21.3788 21.1865C20.5033 22.0622 19.4411 22.5 18.1923 22.5ZM19.8578 20.2885L20.4808 19.6655L18.6348 17.8193V15.0578H17.75V18.1808L19.8578 20.2885Z"
        fill="#1E264C"
      />
    </g>
  </svg>
</template>
